
<template>
  <!--首页top导航 -->
  <div class="head">
    <el-row>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <img src="../assets/logo.png">
        </div>
      </el-col>
      <el-col :span="3">
        <div class="bg-purple-light">
          <!-- 中科锐景 -->
          <span style="color:white;margin-left: -185px;"></span>
        </div>
      </el-col>
      <el-col :span="13">
        <div class="grid-content bg-purple-light">
          <el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal" @select="handleSelect"
            background-color="#191b2e" text-color="#afb1c1" active-text-color="#1ccb96">
            <!-- <router-link to="/">
              <el-menu-item
                index="1"
                style="text-decoration:none"
              >
                首页
              </el-menu-item>
            </router-link> -->
            <router-link to="/remoteSenseData">
              <el-menu-item index="2">
                遥感数据
              </el-menu-item>
            </router-link>
            <router-link to="/remoteSenseProduct">
              <el-menu-item index="3">
                遥感产品
              </el-menu-item>
            </router-link>
            <!-- <router-link to="/112">
              <el-menu-item index="4">
                地基数据
              </el-menu-item>
            </router-link>-->
            <router-link to="/subscriptionData">
              <el-menu-item index="5">
                订制数据
              </el-menu-item>
            </router-link>

          </el-menu>
        </div>
      </el-col>
      <el-col :span="4" v-if="$route.path.indexOf('/home') !== -1">
        <div class="pay">
          <span class="paycar" @click="opencart"><i class="el-icon-shopping-cart-1"></i> 购物车</span>
          <el-badge :value="messageCount" :hidden="messageCount === 0">
            <span class="ld" @click="showMessage"><i class="el-icon-message-solid"><i class="d"></i></i></span>
          </el-badge>
          <span class="tx" @click="userchange"></span>
        </div>
        <div class="user-i" v-show="isshow">
          <ul>
            <i class="el-icon-caret-top"></i>
            <li :class="userSetMenu[0].acitve" @click="menuClick('account')"><a href="javascript:void(0);"><i
                  class="el-icon-setting"></i>个人资料</a></li>
            <li :class="userSetMenu[1].acitve" @click="menuClick('changepwd')"><a href="javascript:void(0);"><i
                  class="el-icon-unlock"></i>修改密码</a></li>
            <li :class="userSetMenu[2].acitve" @click="menuClick('authorcenter')"><a href="javascript:void(0);"><i
                  class="el-icon-switch-button"></i>认证中心</a></li>
            <li :class="userSetMenu[3].acitve" @click="menuClick('address')"><a href="javascript:void(0);"><i
                  class="el-icon-map-location"></i>配送地址</a></li>
            <li @click="logout"><a href="javascript:void(0);"><i class="el-icon-back rightgo"></i>退出账户</a></li>

          </ul>
        </div>
      </el-col>
      <el-col :span="4" v-else>
        <div class="grid-content bg-purple" v-if="user.nickName">
          <span style="color:#afb1c1;font-size:14px;">{{user.nickName}}</span>
          <span style="color:#afb1c1;font-size:14px;">丨</span>
          <a href="javascript:;" @click="toDataOrders" style="color:white" v-popover:userPopover>用户中心</a>
          <el-popover popper-class="newpopover" ref="userPopover" placement="bottom" trigger="hover">
            <div class="popdiv"><i class="el-icon-info rightgo"></i><a href="javascript:;" @click="toDataOrders"
                style="color:#ffffff;font-size:14px;">用户订单</a></div>
            <div class="popdiv" @click="logout"><i class="el-icon-back rightgo"></i>退出账户</div>
          </el-popover>
        </div>
        <div class="grid-content bg-purple" v-else>
          <span>
            <router-link to="register" style="color:#afb1c1;font-size:14px;">注册</router-link>
          </span>
          <span style="color:#afb1c1;font-size:14px;">丨</span>
          <span style="color:#afb1c1;font-size:14px;cursor:pointer;" @click="toLogindialogFormVisible">登录</span>
          <el-dialog title="会员登录" :visible.sync="LogindialogFormVisible" custom-class="accountdialog" append-to-body
            :close-on-click-modal="false">
            <UserLogin v-on:getLogindialogFormVisible="getLogindialogFormVisible" v-on:sendUserInfo="getUserInfo">
            </UserLogin>
          </el-dialog>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import eventBus from '../common/eventBus.js'
import UserLogin from './account/UserLogin'
import store from '../vuex/index.js'
export default {
  name: 'HeadNav',
  props: ['msgFather'],
  components: {
    UserLogin
  },
  data () {
    return {
      LogindialogFormVisible: false,
      activeIndex: '1',
      activeIndex2: '1',
      isshow: false,
      messageCount: 0,
      messageType: '',
      user: {
        userId: '',
        userName: '',
        nickName: '',
        sex: '',
        rank: '',
        accountType: '',
        accessToken: ''
      },
      userSetMenu: [
        {
          name: 'personalInfo',
          active: ''
        },
        {
          name: 'changepwd',
          active: ''
        },
        {
          name: 'authorcenter',
          active: ''
        },
        {
          name: 'address',
          active: ''
        }
      ],
      imageUrl: ''
    }
  },
  mounted () {
    // 修复刷新页面退出登录的问题
    let beforeUnloadTime = 0
    let gapTime = 0
    // 监听浏览器刷新或者关闭的方法
    window.addEventListener('beforeunload', e => {
      beforeUnloadTime = new Date().getTime()
    })
    window.addEventListener('unload', e => {
      gapTime = new Date().getTime() - beforeUnloadTime
      // 浏览器关闭退出登录状态
      if (gapTime <= 5) {
        window.localStorage.removeItem('user')
      }
    })
    // 取session中的用户信息
    if (sessionStorage.getItem('user')) {
      this.getUserInfo()
    }
    if (localStorage.getItem('user')) {
      this.user = JSON.parse(localStorage.getItem('user'))
    }

    eventBus.$on('showLoginDialog', showLogin => {
      this.LogindialogFormVisible = true
    })

    eventBus.$on('logout', success => {
      this.logout()
    })

    eventBus.$on('changeUser', userItem => {
      this.user.nickName = userItem.nickName
    })

    eventBus.$on('getMessageCount', xxx => {
      this.getMessageCount()
    })
    this.initActiveIndex()
    // 给页面添加鼠标抬起事件
    document.addEventListener('mouseup', (e) => {
      if (this.isshow) {
        this.isshow = false
      }
    })
  },
  destroyed () {
    window.removeEventListener()
  },
  methods: {
    toAccount () {
      // <router-link to="/home/account" style="color:#ffffff;font-size:14px;">账户首页</router-link>
      this.activeIndex2 = '0'
      this.$router.push('/home/account')
    },
    toDataOrders () {
      // 跳转到用户订单
      store.commit('setLoading', false)
      this.activeIndex2 = '0'
      this.$router.push('/home/dataOrders')
    },
    initActiveIndex () {
      if (this.$route.path === '/') {
        this.activeIndex2 = '1'
      }
      if (this.$route.path === '/remoteSenseData') {
        this.activeIndex2 = '2'
      }
      if (this.$route.path === '/remoteSenseProduct') {
        this.activeIndex2 = '3'
      }
    },
    handleSelect: function (key, keyPath) {
      this.activeIndex2 = key
    },
    getLogindialogFormVisible (val) {
      this.LogindialogFormVisible = val
    },
    toLogindialogFormVisible (val) {
      this.sapost('/dmc/account/logout', '', r => {
        let { retCode, retMsg } = r.data
        if (retCode === 1) {
          this.$message.error(retMsg)
        } else {
          sessionStorage.removeItem('user')
          sessionStorage.clear()
          localStorage.removeItem('user')
          localStorage.clear()
          this.user.nickName = ''
          eventBus.$emit('logoutSuccess')
          eventBus.$emit('clearCart')
        }
      })
      this.LogindialogFormVisible = true
    },
    getUserInfo () {
      this.user = JSON.parse(sessionStorage.getItem('user'))
      this.user = JSON.parse(localStorage.getItem('user'))
    },
    logout () {
      this.sapost('/dmc/account/logout', '', r => {
        let { retCode, retMsg } = r.data
        if (retCode === 1) {
          this.$message.error(retMsg)
        } else {
          sessionStorage.removeItem('user')
          sessionStorage.clear()
          localStorage.removeItem('user')
          localStorage.clear()
          this.user.nickName = ''
          this.LogindialogFormVisible = false
          eventBus.$emit('logoutSuccess')
          eventBus.$emit('clearCart')
          this.$message.success('退出成功！')
          this.$router.push({
            path: '/remoteSenseData'
          })
        }
      })
    },
    userchange () {
      this.isshow = !this.isshow
    },
    showMessage () {
      this.messageCount = 0
      if (this.$route.name === 'message') {
        eventBus.$emit('showMessage', this.messageType)
      } else {
        this.$router.push({ name: 'message', params: { type: this.messageType } })
        eventBus.$emit('toMessageMenu')
      }
    },
    opencart () {
      this.$router.push({ name: 'mainindex', params: { cartOpen: true } })
    },
    menuClick (currentMenu) {
      this.userSetMenu.forEach((item, index) => {
        if (item.name === currentMenu) {
          this.userSetMenu[index].active = 'active'
        } else {
          this.userSetMenu[index].active = ''
        }
      })
      this.$router.push(`/home/${currentMenu}`)
      this.userchange()
      eventBus.$emit('toAccountMenu')
    },
    getMessageCount () {
      console.log('未读消息查询！')
      this.sapost('/dmc/account/getMessageCount', '', r => {
        let { retMsg, retCode, count, type } = r.data
        if (retCode === '0') {
          this.messageCount = count
          this.messageType = type
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    }
  },
  watch: {
    msgFather (val) {
      if (val) {
        this.logout()
      }
    }
  }

}
</script>
<style lang="less">
.pay {
  font-size: 14px;
  float: right;
  color: #6e757b;
  margin-right: 15px;
  span {
    margin: 0px 15px;
  }
  .el-badge__content.is-fixed {
    top: 15px;
  }
  .ld {
    font-size: 18px;
    margin: 0px;
    cursor: pointer;
    // .d{
    //   display: inline-block;
    //   width: 6px;
    //   height: 6px;
    //   border-radius: 3px;
    //   background-color: red;
    //   vertical-align: top;
    // }
  }
  .paycar {
    border: 1px solid #bfbfbf;
    padding: 5px 15px;
    border-radius: 15px;
    cursor: pointer;
  }
  .tx {
    margin-top: -5px;
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background: url("../assets/img/tx.png") no-repeat center;
    background-size: 100%;
    vertical-align: middle;
    overflow: hidden;
    cursor: pointer;
  }
}
.user-i {
  position: absolute;
  background-color: #fff;
  font-size: 12px;
  z-index: 99;
  width: 120px;
  right: 24px;
  border-radius: 3px;
  margin-top: 66px;
  ul {
    overflow: hidden;
    li {
      width: 100px;
      padding: 0 10px;
      height: 28px;
      line-height: 28px;
      i {
        margin-right: 10px;
      }
    }
    li:hover,
    li.acitve {
      a {
        color: #fff;
      }
      background-color: #ee4242;
    }
  }
  .el-icon-caret-top {
    color: #fff;
    position: absolute;
    top: -8px;
    right: 20px;
  }
}
.accountdialog {
  width: 360px;
  border-radius: 12px;
  padding: 0px 5px 20px 5px;
  min-width: 360px;
  margin: 0 auto 50px;
  .el-dialog__title {
    color: rgb(28, 203, 150);
    font-weight: bold;
    font-size: 16px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .el-dialog__header {
    background: none;
    border-radius: 8px 8px 0 0;
    height: 0;
  }
}
.router-link-active {
  text-decoration: none;
}
.router-link-exact-active {
  border-bottom: #1ccb96 2px solid;
}
a {
  text-decoration: none;
}
.el-menu-item.is-active {
  height: 58px;
}
.grid-content {
  background-color: #191b2e;
  height: 60px;
  text-align: right;
  padding-right: 70px;
}
.el-menu.el-menu--horizontal {
  border-bottom: none;
}
.el-menu-demo {
  display: flex;
  justify-content: space-around;
}
.el-menu-item * {
  text-decoration: none;
  vertical-align: middle;
}
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/HeadNav.vue